import { IncomingCheckoutSessionUpdateDto } from 'api/dtos/events/checkout';
import { CheckoutUpdateDataToSend } from '../../types';

/**
 * Computes the updated checkout session parameters to be sent to the API.
 */
const computeCheckoutSessionUpdate = (
  updateData: CheckoutUpdateDataToSend,
  isUserAuthenticated?: boolean
): IncomingCheckoutSessionUpdateDto => {
  const body: IncomingCheckoutSessionUpdateDto = {
    discountCode: updateData.discountCode || undefined,
    ticketBasket: {},
    tierShareTokens: [],
    promoterCode: updateData.promoterCode || undefined,
    trackingId: updateData.trackingId || undefined
  };

  // Unauthenticated users can't have a payment method assigned to them
  if (isUserAuthenticated) {
    if (updateData.stripePaymentMethodType) {
      body.stripePaymentMethodType = updateData.stripePaymentMethodType;
    } else if (updateData.stripePaymentMethodId) {
      body.stripePaymentMethodId = updateData.stripePaymentMethodId;
    }
  }

  if (updateData.ticketTiers) {
    body.ticketBasket = Object.keys(updateData.ticketTiers).reduce(
      (basket, tierId) => {
        basket[tierId] = updateData.ticketTiers[tierId].quantity;
        return basket;
      },
      {}
    );
  }

  if (updateData.privateTierCodes) {
    body.tierShareTokens = Object.values(updateData.privateTierCodes);
  }

  return body;
};

export default computeCheckoutSessionUpdate;
